import React from "react";
import DeactiveAccountContextProvider, {
    DeactiveAccountContext,
    ACTIONS
} from "../../context/DeactiveAccountContextProvider";
import { CGE } from "../../../../common/components/CGE";

const DeactiveAccount = ({ props }) => {
    const [state, dispatch] = React.useContext(DeactiveAccountContext);

    function handleClick() {
        dispatch({
            payload: true,
            type: ACTIONS.SET_DEACTIVE_ACCOUNT,
        });
    }

    React.useEffect(() => {
        if (state.deactiveAccountResponse) {
            const objResponse = state.deactiveAccountResponse;

            if (objResponse?.out === "NOK" || objResponse.length === 0 ) {
                props.setGlobalAlert("No se puede desactivar su cuenta de internet", "danger", true, "Error");
            } else {
                props.setGlobalAlert("Cuenta de internet desactivada con éxito", "success");
                setTimeout(() => {
                    window.location.href = "cierre-sesion";
                }, 2000);
            }
        }
    }, [state.deactiveAccountResponse]);

    return (
        <CGE.Panel title={props.title_deactive_account} >
            <CGE.Spacing type="gn" />
            <CGE.PanelContainer alingItensCenter={true} size="md" >
                <CGE.Text size="5" className="text-center" text="Informamos que al desactivar tu cuenta, se eliminarán también, todos los accesos a las aplicaciones que tengas en CGE, como por ejemplo la App CGE1Click." />
                <CGE.Text size="5" className="text-center" text="¿Estás seguro que deseas desactivar tu cuenta de Internet?" />
            </CGE.PanelContainer>
            <CGE.Spacing type="gn" />
            <CGE.Spacing type="gn" />
            <CGE.InlineRow className=" d-flex justify-content-between">
                <CGE.InlineCol>
                    <CGE.Button
                        label="Volver"
                        onClick={() => { window.history.back() }}
                        type="secondary"
                    />
                </CGE.InlineCol>
                <CGE.InlineCol>
                    <CGE.Button
                        label="Desactivar"
                        onClick={() => { handleClick() }}
                        type="primary"
                    />
                </CGE.InlineCol>
            </CGE.InlineRow>
        </CGE.Panel>
    );
};

const DeactiveAccountWithProvider = ({ props }) => (
    <DeactiveAccountContextProvider>
        <DeactiveAccount props={props} />
    </DeactiveAccountContextProvider>
);
export default DeactiveAccountWithProvider;
